module.exports = __webpack_public_path__ + "img/chat-right-text.b9fabae7.svg";